import { injectGlobal } from 'emotion'

injectGlobal`
  @font-face{
    font-family: 'Interstate-ExtraLight';
    font-style: normal;
    font-weight: 200;
    src: url(${require('./../static/fonts/Interstate-ExtraLight.eot')});
    src: local('Interstate-ExtraLight'), local('Interstate-ExtraLight'),
         url(${require('./../static/fonts/Interstate-ExtraLight.eot')}) format('embedded-opentype'),
         url(${require('./../static/fonts/Interstate-ExtraLight.woff2')}) format('woff2'),
         url(${require('./../static/fonts/Interstate-ExtraLight.woff')}) format('woff'),
         url(${require('./../static/fonts/Interstate-ExtraLight.ttf')}) format('truetype'),
         url(${require('./../static/fonts/Interstate-ExtraLight.svg')}) format('svg');
  }

  @font-face{
    font-family: Interstate-bold;
    font-style: normal;
    font-weight: bold;
    src: url(${require('./../static/fonts/Interstate-Bold.eot')}); /* IE9 Compat Modes */
    src: local('Interstate-Bold'), local('Interstate-Bold'),
         url(${require('./../static/fonts/Interstate-Bold.eot?#iefix')}) format('embedded-opentype'),
         url(${require('./../static/fonts/Interstate-Bold.woff2')}) format('woff2'),
         url(${require('./../static/fonts/Interstate-Bold.woff')}) format('woff'),
         url(${require('./../static/fonts/Interstate-Bold.ttf')}) format('truetype');
  }

  @font-face{
    font-family: Interstate-Bold-Condensed;
    font-style: normal;
    font-weight: bold;
    src: local('Interstate-Bold-Condensed'), local('Interstate-Bold-Condensed'),
         url(${require('./../static/fonts/Interstate-Bold-Condensed.woff2')}) format('woff2'),
         url(${require('./../static/fonts/Interstate-Bold-Condensed.woff')}) format('woff');
  }
`


// WEBPACK FOOTER //
// ./src/styles/fonts.js